// @ts-strict-ignore
import React from "react";
import { RouteComponentProps, useLocation } from "react-router-dom";
import { parse as parseQs } from "qs";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { useIntl } from "react-intl";
import { sectionNames } from "@dashboard/intl";
import { ConditionalOrderFilterProvider } from "@dashboard/components/ConditionalFilter";
import OrderListComponent from "@dashboard/orders/views/OrderList";
import { asSortParams } from "@dashboard/utils/sort";
import {
  OrderListUrlSortField,
  OrderListUrlQueryParams,
} from "@dashboard/orders/urls";

interface VendorMyOrdersListProps {
  location: ReturnType<typeof useLocation>;
}

const VendorMyOrdersList = ({ location }: VendorMyOrdersListProps) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: OrderListUrlQueryParams = asSortParams(
    qs,
    OrderListUrlSortField,
    OrderListUrlSortField.number,
    false,
  );

  return (
    <ConditionalOrderFilterProvider locationSearch={location.search}>
      <OrderListComponent params={params} />
    </ConditionalOrderFilterProvider>
  );
};

const Component = () => {
  const intl = useIntl();
  const location = useLocation();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.orders)} />
      <VendorMyOrdersList location={location} />
    </>
  );
};

export default Component;